/** components/Input.tsx */
import { AtomInput, AtomInputProps } from '@/atoms/input'
import { css } from '@emotion/react'
import { Interpolation, Theme } from '@emotion/react/dist/declarations/src'
import { forwardRef } from 'react'
import { useTheme } from '@emotion/react'

const checkBoxItemStyle = css`
  display: flex;
  align-items: center;
  column-gap: 4px;
`
const boxStyle = (t: Theme) => css`
  appearance: none;
  position: relative;
  width: 20px;
  height: 20px;
  border: 1px solid ${t.c.bc.primary};
  border-radius: 4px;
  cursor: pointer;
  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 3px;
    width: 12px;
    height: 6px;
    // border-bottom: 2px solid ${t.c.ec.white};
    // border-left: 2px solid ${t.c.ec.white};
    border-bottom: 2px solid ${t.c.bc.primary};
    border-left: 2px solid ${t.c.bc.primary};
    transform-origin: left top;
    transform: rotate(-45deg);
    animation: check 0.5s;
  }

  @keyframes check {
    0% {
      height: 0;
      width: 0;
    }
    25% {
      height: 6px;
      width: 0px;
    }
    50% {
      height: 6px;
      width: 12px;
    }
  }
`

type Props = {
  label: string
  isChecked: boolean
  addStyle?: Interpolation<Theme>
} & AtomInputProps

export const CheckBox = forwardRef<HTMLInputElement, Props>(
  ({ label, isChecked, addStyle, ...attr }: Props, ref) => {
    const theme = useTheme()
    return (
      <div css={checkBoxItemStyle}>
        <AtomInput
          type="checkbox"
          {...attr}
          ref={ref}
          css={[boxStyle(theme), addStyle]}
          checked={isChecked}
        />
        <span>{label}</span>
      </div>
    )
  },
)
